<template>
  <div class="registerInfo">
    <div class="header-wrapper">
      <div class="main-wrapper">
        <div class="logon-content" style="position: relative">
          <div style="font-size: 30px; color: white; position: absolute; bottom: 0px">
            <span>BigData On K8s</span>
          </div>
          <div style="font-size: 18px; color: white; position: absolute; bottom: 0px; right: 0px">密码重置</div>
        </div>
      </div>
    </div>

    <div class="main-wrapper">
      <div class="content-wrapper">
        <div>
          <el-form ref="form" :model="form" :rules="rules" label-width="210px">

            <div class="item-wrapper">
              <div class="item-title" style="font-size: 17px">
                <span style="color: #3888d7; font-weight: bold">|</span>
                <span style="margin-left: 2px; color: #333333">密码重置</span>
              </div>

              <div class="item-content">
                <div class="resetPasswordNote">流程：1、提交核实信息；2、接收系统发送的重置密码；3、登录平台修改密码</div>
                <el-form-item label="注册邮箱" prop="email">
                  <el-input v-model="form.email" type="text"
                            placeholder="请填写注册预留邮箱"
                            style="width: 420px"></el-input>
                </el-form-item>

                <el-form-item label="登录手机号码" prop="loginPhone">
                  <el-input v-model="form.loginPhone" type="text" oninput="value=value.replace(/[^\d]/g,'')"
                            maxlength="11"
                            placeholder="请填写11位当前用于登录系统的手机号码"
                            style="width: 420px"></el-input>
                </el-form-item>

                <el-form-item label="短信验证码" prop="code">
                  <el-input v-model="form.code" type="text" oninput="value=value.replace(/[^\d]/g,'')"
                            maxlength="6"
                            placeholder="请填写6位短信验证码"
                            style="width: 220px"></el-input>
                    <span>
                        <el-button type="danger"
                                   :disabled="!rightPhone"
                                   style="width: 196px; height: 40px;"
                                   @click.prevent="getCode">
                          <!--发送验证码-->
                          {{ computeTime ? `已发送(${computeTime})s` : '获取验证码'}}
                        </el-button>
                    </span>
                </el-form-item>
                <div class="" style="width: 630px;">
                  <div style="width: 120px; margin-left: 510px;">
                    <el-button type="danger" style="width: 120px;"
                               @click="submit">提 交
                    </el-button>
                  </div>
                </div>
              </div>

            </div>

          </el-form>
        </div>

      </div>
    </div>

    <section class="login-footer">
      <div class="login-copyright">Copyright &copy;{{currentYear}} bigdataonk8s.com 版权所有
        <div class="login-copyright-police"><img
          src="/static/images/PSO.png"
          class="police-img">
          <a class="login-copyright" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44040202001433">
                      <span style="cursor: pointer;">粤公网安备
                                            44040202001433号</span>
          </a>
          <div class="BeastCoreDivider__vertical__3vxv8__2-33-1"></div>
          <a class="login-copyright" target="_blank" href="http://beian.miit.gov.cn">
            <span style="cursor: pointer;">粤ICP备2023032905号-1</span>
          </a>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import {
  checkPhone,
  checkEmail
} from '@/common/utils.js'
import {
  reqResetPassword,
  reqResetPasswordSendCode
} from '@/api'

export default {
  name: 'ResetPassword',

  data() {

    return {
      computeTime: 0,
      form: {
        loginPhone: '',
        code: '',
        email: ''
      },
      rules: {
        email: [
          { required: true, validator: checkEmail, trigger: 'blur' }
        ],
        loginPhone: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请填写短信验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '请填写6位短信验证码', trigger: 'blur' }
        ]
      }
    };
  },

  methods: {
// 获取短信验证码
    async getCode () {
      // computeTime等于0的时候才执行
      if (!this.computeTime) {
        this.computeTime = 60
        this.intervalId = setInterval(() => {
          this.computeTime--
          if (this.computeTime <= 0) {
            clearInterval(this.intervalId)
          }
        }, 1000)

        // 发送ajax请求
        const result = await reqResetPasswordSendCode(this.form.loginPhone)
        if (result.code === 1) {
          this.$alert(`${ result.message }`, '错误', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          if (this.computeTime) {
            this.computeTime = 0
            clearInterval(this.intervalId)
          }
        }
      }
    },

    submit () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const result = await reqResetPassword(this.form.loginPhone.trim(), this.form.code.trim(), this.form.email.trim())
          this.$alert(`${ result.message }`, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          if (result.code === 0) {
            this.$refs.form.resetFields()
            this.$router.replace('/login')
          }
        } else {
          this.$alert('输入信息不正确，请完善后再提交！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
      })
    }
  },

  mounted () {
  },

  computed: {
    rightPhone () {
      return /^1\d{10}$/.test(this.form.loginPhone)
    },

    currentYear: function () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
  .registerInfo {
    background-color: #f1f1f1;
    height: 576px;
  }

  .header-wrapper {
    widht: 100%;
    height: 80px;
    background-color: #c13532;
    border: 1px solid;
    border-bottom-color: #f9d993;
  }

  .logon-content {
    width: 340px;
    height: 40px;
    float: left;
    margin-top: 20px;
  }

  .resetPasswordNote {
    color: #666666;
    margin: 24px 0;
  }


  .main-wrapper {
    /*width: 60%;*/
    width: 960px;
    height: 576px;
    margin-left: auto;
    margin-right: auto;
  }

  .content-wrapper {
    background-color: #fff;
    height: 576px;
  }

  .item-wrapper {
    padding: 40px 60px 0px 60px;
  }


  .item-content {
    margin: 20px 0px;
  }


  .login-footer {
    text-align: center;
    height: 168px;
    padding-top: 35px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .login-footer .footer-tab {
    margin-bottom: 20px;
  }

  .login-footer .footer-tab .link-text {
    display: inline-block;
    height: 16px;
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    line-height: 16px;
    cursor: pointer;
  }

  .login-footer .footer-tab .link-text:hover {
    text-decoration: underline;
  }

  .login-footer .footer-tab .link-text:last-child {
    border-right: none;
  }

  .login-footer .login-copyright {
    font-size: 12px;
    color: #999;
    padding-bottom: 15px;
    line-height: 1.5;
  }

  .login-footer .login-copyright .login-copyright-police {
    margin-top: 6px;
  }

  .login-footer .login-copyright .login-copyright-police .police-img {
    height: 12px;
    width: 12px;
    margin-right: 3px;
    position: relative;
    top: -1px;
  }

  .BeastCoreDivider__vertical__3vxv8__2-33-1 {
    border-right: 1px solid #ebebeb;
    position: relative;
    margin: 0 8px;
    top: -0.06em;
    display: inline-block;
    vertical-align: middle;
    height: 0.9em;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword/ResetPassword.vue